import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import logoUrl from '@/assets/uknowva-hrms-logo.png';

/**
 * The frame around every signup page — the login page's look, but it owns its
 * own scrolling: the theme pins html/body to the viewport for the AppShell's
 * sake, and a signup form is taller than a phone screen.
 */
export function SignupShell({
  title,
  subtitle,
  width = 520,
  children,
}: {
  title: string;
  subtitle?: React.ReactNode;
  width?: number;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        height: '100vh',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        // "safe center" avoids clipping the card's top on short windows.
        alignItems: { xs: 'flex-start', sm: 'safe center' },
        p: { xs: 2, sm: 3 },
        background:
          'radial-gradient(1200px 600px at 100% 0%, rgba(16,138,230,0.14), transparent 55%),' +
          'radial-gradient(900px 500px at 0% 100%, rgba(16,138,230,0.10), transparent 50%),' +
          'linear-gradient(135deg, #eef5fd 0%, #f4f7fb 50%, #eaf1f9 100%)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2.5, sm: 4.5 }, maxWidth: width, width: '100%', my: { xs: 1, sm: 3 },
          borderRadius: 3, border: 1, borderColor: 'rgba(16,138,230,0.14)',
          boxShadow: '0 18px 48px rgba(24,40,72,0.14)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box component="img" src={logoUrl} alt="uKnowva"
            sx={{ height: 36, width: 'auto', display: 'block' }} />
        </Box>
        <Typography variant="h2" sx={{ textAlign: 'center', mb: 0.5 }}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Box>
  );
}
